import { gql } from "@apollo/client";
import { BaseMutationTuple, jssaQuery, useBaseMutation } from "./index";
import { ProductListingToPayoutRule } from "../../../common/models";
import { ProductListingToPayoutRuleInput, PLPRCreateInput, PLPRUpdateInput } from "../../../common/inputs/ProductListingToPayoutRuleInput";
import { plprAllFieldsFragment } from "./CommonQueries";

export const payoutRuleMappingsByProductListingQuery = gql`
    ${plprAllFieldsFragment}
    query payoutRuleMappingsByProductListing(
        $productListingId: String!,
        $options: ProductListingToPayoutRuleInput
    ) {
        payoutRuleMappingsByProductListing(
            productListingId: $productListingId,
            options: $options
        ) {
            ...PLPRAllFields
        }
    }
`;

export const assignPayoutRuleToProductListingMutation = gql`
    ${plprAllFieldsFragment}
    mutation assignPayoutRuleToProductListing($data: PLPRCreateInput!) {
        assignPayoutRuleToProductListing(data: $data) {
            ...PLPRAllFields
        }
    }
`;

export const updatePayoutRuleMappingMutation = gql`
    ${plprAllFieldsFragment}
    mutation updatePayoutRuleMapping($data: PLPRUpdateInput!) {
        updatePayoutRuleMapping(data: $data) {
            ...PLPRAllFields
        }
    }
`;

export const useCreatePayoutRuleMappingMutation = (): BaseMutationTuple<PLPRCreateInput, ProductListingToPayoutRule> => {
    const transformInput = (input: PLPRCreateInput) => {
        return { data: input };
    };

    const transformOutput = (output: any) => {
        return output.assignPayoutRuleToProductListing;
    };

    return useBaseMutation<PLPRCreateInput, ProductListingToPayoutRule>(
        assignPayoutRuleToProductListingMutation,
        transformInput,
        transformOutput,
    );
};

export const useUpdatePayoutRuleMappingMutation = (): BaseMutationTuple<PLPRUpdateInput, ProductListingToPayoutRule> => {
    const transformInput = (input: PLPRUpdateInput) => {
        const cleaned = { ...input } as any;
        delete cleaned.createdAt;
        delete cleaned.updatedAt;
        delete cleaned.payoutRule;
        delete cleaned.costPayoutModifier;
        delete cleaned.productListing;
        return { data: cleaned };
    };

    const transformOutput = (output: any) => {
        return output.updatePayoutRuleMapping;
    };

    return useBaseMutation<PLPRUpdateInput, ProductListingToPayoutRule>(
        updatePayoutRuleMappingMutation,
        transformInput,
        transformOutput,
    );
};

export interface PayoutRuleMappingQueryFilters {
    productListingId: string;
    options?: ProductListingToPayoutRuleInput;
}

export const queryPayoutRuleMappingsByProductListing = async (
    filters: PayoutRuleMappingQueryFilters
): Promise<ProductListingToPayoutRule[]> => {
    const { data: { payoutRuleMappingsByProductListing } } = await jssaQuery({
        query: payoutRuleMappingsByProductListingQuery,
        variables: {
            productListingId: filters.productListingId,
            options: filters.options,
        },
    });
    return payoutRuleMappingsByProductListing;
};
